import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import ListRegisterService from "./ListRegisterService";
import SearchRegisterService from "./SearchRegisterService";
import RegisterServicePopup from "../Popup/RegisterServicePopup";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Add, KeyboardArrowRight } from "@material-ui/icons";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import {
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleHisReadOnly,
  isSalesConsultant,
  transformDate,
} from "app/common/LocalFunction";
import moment from "moment";
import * as Yup from "yup";
import FilterListIcon from "@material-ui/icons/FilterList";
import CommonButton from "app/common/Component/Button/CommonButton";
import PrintPopupTreamentPlanTab from "../PrintTreatmentPlanTab/PrintPopupTreamentPlanTab";
import PrintIcon from "@material-ui/icons/Print";
import { Button, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import RegisterServiceHistoryPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/RegisterServiceTreatmentPlanTab/Popup/RegisterServiceHistoryPopup";
const RegisterServiceIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  let [open, setOpen] = useState(true);
  let [isOpenFillter, setOpenFillter] = useState(true);
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchService({
        ...searchRegisterService,
        patientId,
        getStaffRevenues: true,
        fromDate: null,
        toDate: null,
      });
    }
  }, [patientId]);
  const {
    searchRegisterService,
    handleChangeFormSearchService,
    openCreateOrEditServicePopup,
    handleOpenCreateOrEditServicePopup,
    handleCloseCreateOrEditServicePopup,
    saveOrUpdateRegisterService,
    initRegisterService,
    resetPopupStore,
    openConfirmDelete,
    handleOpenConfirmDelete,
    handleDeleteService,
    pageRegisterService,
    openPrintService,
    handleClosePrintService,
    selectedRowService,
    setOpenPopupPrintService,
    openConfirmDeleteMessage,
    handleCloseDeleteConfirmMessage,
    handleCloseRegisterServiceHistoryPopup,
    openRegisterServiceHistoryPopup,
  } = useStore().patientManagementStore.registerServiceStore;
  const { listVatPercent, initialPatient, customerSourceWalkIn, handleGetPatientOverviewById } =
    useStore().patientManagementStore.patientGeneralStore;
  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });

  let isAdminPermission = isAdmin();
  let isRoleCashierPermission = isRoleCashier();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  let isSalesConsultantPermission = isSalesConsultant();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  return (
    <section className="form-patient mt-0" style={{ margin: "4px" }}>
      <div style={{ backgroundColor: "#bdfff342", padding: "5px" }}>
        <div
          className="flex justify-between"
          style={{ fontSize: "16px", gap: "5px", fontWeight: "bold" }}
        >
          <p className="cards-header flex align-center item-form-header-custom">
            <span
              className="flex items-center pointer"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRight />}
              1. Dịch vụ lẻ
            </span>
            <span
              style={{ cursor: "pointer" }}
              className="flex items-center"
              onClick={() => setOpenFillter(!isOpenFillter)}
            >
              <FilterListIcon color="red" />
            </span>
          </p>
          <div className="flex gap-2">
            {/* <CommonButton
              className="btn-add"
              onClick={async (e) =>
                setAnchorEl(anchorEl ? null : e.target)
              }
              style={{ position: "relative", height: "100%" }}
            >
              <Add />
                In phiếu
            </CommonButton> */}
            {!isMobile && selectedRowService?.length > 0 && (
              <Tooltip title={"In tùy chọn"}>
                <Button
                  onClick={() => {
                    setOpenPopupPrintService(true);
                  }}
                  style={{ backgroundColor: "#f16321", color: "white" }}
                >
                  <PrintIcon />
                  {isMobile || "In phiếu tùy chọn"}
                </Button>
              </Tooltip>
            )}
            {!isMobile ||
              (!isReadonly && (
                <Tooltip title={"In tất cả dịch vụ"}>
                  <Button
                    onClick={() => setOpenPopupPrintService(true)}
                    style={{ backgroundColor: "#f16321", color: "white" }}
                  >
                    <PrintIcon />
                    {isMobile || "In phiếu"}
                  </Button>
                </Tooltip>
              ))}

            {(isAdminPermission ||
              isRoleCashierPermission ||
              isRoleBranchManagerPermission ||
              isSalesConsultantPermission) && (
              <CommonButton
                className="btn-add"
                onClick={() => {
                  handleOpenCreateOrEditServicePopup();
                }}
              >
                <Add />
              </CommonButton>
            )}
          </div>
        </div>
        {open && (
          <Formik
            initialValues={searchRegisterService}
            validationSchema={searchPatientValidationSchema}
            onSubmit={(values) => {
              handleChangeFormSearchService({
                ...values,
                getStaffRevenues: true,
              });
            }}
            enableReinitialize
          >
            <Form autoComplete="off">
              {!isOpenFillter && (
                <>
                  <style>
                    {`
                      @keyframes slideDownFade {
                        0% {
                          opacity: 0;
                          transform: translateY(-10px);
                        }
                        100% {
                          opacity: 1;
                          transform: translateY(0);
                        }
                      }
                    `}
                  </style>
                  <div
                    style={{
                      animation: "slideDownFade 0.3s ease forwards",
                      zIndex: 10,
                      position: "relative",
                    }}
                  >
                    <SearchRegisterService
                      handleOpenCreateOrEditPopup={
                        handleOpenCreateOrEditServicePopup
                      }
                    />
                  </div>
                </>
              )}
              <ListRegisterService />
            </Form>
          </Formik>
        )}
        {!!openCreateOrEditServicePopup && (
          <RegisterServicePopup
            open={!!openCreateOrEditServicePopup}
            handleClose={handleCloseCreateOrEditServicePopup}
            resetPopupStore={resetPopupStore}
            onSubmit={saveOrUpdateRegisterService}
            handleAfterSubmit={() => handleGetPatientOverviewById(patientId)}
            initRegisterService={{ ...initRegisterService, patientId }}
            listVatPercent={listVatPercent}
            customerSourceWalkIn={customerSourceWalkIn}
          />
        )}
        {openConfirmDelete && (
          <ConfirmPopup
            open={openConfirmDelete}
            onClose={() => handleOpenConfirmDelete(null)}
            text="Bạn có chắc chắn muốn xóa dịch vụ này không ?"
            onConfirm={async () => {
              await handleDeleteService(); 
              if (patientId) {
                await handleGetPatientOverviewById(patientId); 
              }
            }}
          />
        )}

        {!!openConfirmDeleteMessage && (
          <ConfirmPopup
            open={!!openConfirmDeleteMessage}
            onClose={() => handleCloseDeleteConfirmMessage(null)}
            text={openConfirmDeleteMessage}
            hideConfirm
            textClose={"Quay lại"}
            title="Thao tác thất bại"
          />
        )}

        {!!openRegisterServiceHistoryPopup && (
          <RegisterServiceHistoryPopup
            open={!!openRegisterServiceHistoryPopup}
            handleClose={handleCloseRegisterServiceHistoryPopup}
          />
        )}

        {openPrintService && (
          <PrintPopupTreamentPlanTab
            open={openPrintService}
            handleClose={() => {
              handleClosePrintService();
            }}
            dataRegisterService={
              selectedRowService?.length > 0
                ? selectedRowService
                : pageRegisterService?.content || []
            }
            patient={initialPatient}
          />
        )}
      </div>
    </section>
  );
};

export default memo(observer(RegisterServiceIndex));
